module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_05-d39cd6bc4c3a0cbbe9ff66e31849079c.png";